module.exports = __webpack_public_path__ + "img/thumbnail_WhiteFacedSaki_f_normal.07f2d840.png";